import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LoginService from '../services/LoginService';
import useToast from '../shared/utilities/Toast';
import UserService from '../services/UserService';
import { CircularProgress } from '@mui/material';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright � '}
            <Link color="inherit" href="https://mui.com/">
                Your Website
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function ForgotPassword() {
    const { showErrorMessage, showSuccessMessage } = useToast();
    const [ready, setReady] = React.useState<boolean>(true);
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const emailAddressValue = data.get('email')?.toString();
        const passwordValue = data.get('password')?.toString();
        if (emailAddressValue == null || emailAddressValue == '') {
            showErrorMessage('You must enter an email!');
        }
        else {
            setReady(false);
            const successfulLogin = await UserService.ForgotPassword(emailAddressValue);
            if (!successfulLogin) {
                showErrorMessage('Error occured trying to send reset password link!');
            }
            else {
                showSuccessMessage('Successfully sent reset password to link to ' + emailAddressValue);
            }
            setReady(true);

        }

    };

    return (
        <>
            <nav className="navbar sticky-top navbar-dark bg-dark navbar-expand-lg">
                <div className="container">
                    <a href="/">
                        <img src="https://hiddenglen.ca/img/logo.png" alt="hidden glen" />
                    </a>
                    <a className="nav-link" href="https://hiddenglen.ca/">
                        Back
                    </a>
                </div>
            </nav>
            <Container component="main" maxWidth="xs">

                <CssBaseline />

                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    {!ready &&
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <CircularProgress size={100} disableShrink />
                        </div>
                    }
                    {ready &&
                        <>
                            <Typography component="h1" variant="h5">
                                Forgot Password
                            </Typography>
                            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    autoComplete="email"
                                    autoFocus
                                />
                                <Button
                                    color="primary"
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}>
                                    Send Link
                                </Button>
                                <Button
                                    color="primary"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}
                                    onClick={() => { window.location.href = '/login' }}
                                >
                                    Back To Login
                                </Button>

                            </Box>
                        </>
                    }
                </Box>
            </Container>
        </>
    );
}